<template>
  <div class="bindPhone">
    <Navbar title="换绑手机号" :default-bg="false" :service="true"/>
    <div class="cart-box">
      <div class="cart">
        <div class="describe">
          <input type="text" placeholder="请输入新手机号" v-model="phone"
                 @input="changeInputVal($event,/^(0+)|[^\d]+/g,'phone',0,11)"/>
        </div>
        <div class="describe">
          <input type="text" placeholder="请输入图片验证码" v-model="code"
                 @input="changeInputVal($event,/^[^\d]+/g,'code',0,4)"/>
          <img :src="verifyCodeImg" alt="" @click="getImgVerifyCode">
        </div>
        <div class="describe">
          <input type="text" placeholder="请输入手机验证码" v-model="verifyCode"
                 @input="changeInputVal($event,/^[^\d]+/g,'verifyCode',0,6)"/>
          <verifyButton :phone="phone" :type="1" :code="code" :token="token" @resetImgVerifyCode="getImgVerifyCode"/>
        </div>
      </div>
    </div>
    <div class="btn">
      <button class="themeColor" @click="editPhone">确 定</button>
    </div>
  </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import verifyButton from "../../components/verifyButton";
import {mixins} from "../../mixins";
import {Toast} from "vant";

export default {
  name: "bindPhoneStep2",
  components: {Navbar, verifyButton},
  mixins: [mixins],
  data() {
    return {
      phone: null,
      code: null,
      verifyCodeImg: "",
      verifyCode: null,
      token: '',
    }
  },
  created() {
    this.getImgVerifyCode();
  },
  methods: {
    changeInputVal(e, reg, key, min = 0, max) {
      this[key] = e.target.value.replace(reg, '').slice(min, max);
    },
    //修改手机号
    editPhone() {
      let reg = /^1[3456789]\d{9}$/;
      if (this.judgePhone && !reg.test(this.phone)) {
        return Toast("手机号码不正确，请重新输入");
      }
      if (!this.verifyCode) {
        return Toast('请输入手机验证码');
      }
      let data = {
        phone: this.phone,
        code: this.verifyCode,
        smsToken: sessionStorage.getItem('smsToken')
      }
      this.$post('user/modify', data).then(result => {
        if (result.status === 200) {
          this.$router.push('/my/index');
          Toast('绑定成功');
        } else {
          return Toast(result.msg);
        }
      });
    }
  }
}
</script>

<style scoped lang="less">
.bindPhone {
  font-size: 15px;

  .cart-box {
    padding: 0 15px;
    box-sizing: border-box;
    margin-top: 20px;

    .cart {
      background: #FFFFFF;
      padding: 0 20px;
      box-sizing: border-box;
      border-radius: 8px;

      .describe:last-child {
        border-bottom: none;
      }

      .form-item {
        height: 50px;
        margin-top: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #DDDDDD;

        input {
          flex: 1;
          border: none;
        }

      }

      .describe {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #EEEEEE;

        input {
          border: none;
          flex: 1;
        }

        button {
          background: transparent;
          color: #126AFC;
          border: none;
        }

        img {
          width: 100px;
          height: 35px;
        }
      }
    }
  }

  .btn {
    padding: 0 15px;
    box-sizing: border-box;
    margin-top: 70px;

    button {
      width: 100%;
      height: 50px;
      border: none;
      border-radius: 25px;
      font-size: 18px;
      font-weight: bold;
    }
  }
}
</style>